"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.CONGRATS_CONTENT_AUTOPAY_EXPERIMENT = exports.CONGRATS = void 0;
exports.CONGRATS = {
    CONTENT: {
        HEADER: 'Congrats!',
        BODY: 'You’re ready to split your rent!',
        BODY_BOLD: 'Flex service will begin with your {{date}} rent bill.',
        BODY_ONE: 'Flex will start with your',
        BODY_TWO: 'bill. Check your email for more info.',
        DOWNLOAD: 'Download the app to keep up to date with your Flex status.',
        CTA: 'Finish'
    },
    REMEMBER_CARD: {
        HEADER: 'Remember...',
        BODY_ONE_BOLD: 'Flex pays rent to your property on your behalf.',
        BODY_ONE: 'If you have autopay set up in your rent portal, turn it off.',
        BODY_TWO_BOLD: 'Flex will charge your card for your monthly payments.',
        BODY_TWO: 'Ensure you have the funds available when rent is due.'
    },
    FA_REMEMBER_CARD: {
        HEADER: 'Remember...',
        BODY_ONE_BOLD: 'Use the Flex app when you’re ready to pay rent.',
        BODY_ONE: 'You can start as soon as you know your bill amount and have your 1st payment ready.',
        BODY_TWO_BOLD: 'Use a Flex {{paymentMethod}} to pay your rent in full.',
        BODY_TWO: 'After your 1st payment, we’ll give you bank account info to use in your rent portal.'
    }
};
exports.CONGRATS_CONTENT_AUTOPAY_EXPERIMENT = {
    CONTENT: __assign(__assign({}, exports.CONGRATS.CONTENT), { BODY: '', BODY_ONE: 'You’re ready to split your rent, starting with your', BODY_TWO: 'bill. Check your email for more info.' }),
    REMEMBER_CARD_AUTOPAY_OFF: __assign(__assign({}, exports.CONGRATS.REMEMBER_CARD), { BODY_TWO_BOLD: 'You’ll need to initiate your payment each month.', BODY_TWO: 'Head to the Flex app when rent is due to split your rent.' }),
    REMEMBER_CARD_AUTOPAY_ON: __assign(__assign({}, exports.CONGRATS.REMEMBER_CARD), { BODY_TWO_BOLD: 'Flex will charge your card for your monthly payments.', BODY_TWO: 'Ensure you have the funds available when rent is due.' })
};
